module.exports = __webpack_public_path__ + "static/media/simplonbp-medium-webfont.791b1a06.eot";